<!-- 影院列表-->
<template>
	<div class="root-wrap fx-column">
		<div class="header-wrap">
			<Header type="light"></Header>
			<screen-area
				@change="regionChange"
				@selectType="selectType"
			></screen-area>
		</div>

		<div v-if="changeType == 1" class="body-wrap fx-fill">
			<van-list
				v-model="listLoading"
				:finished="listFinished"
				finished-text="- 已加载完全部影院 -"
				@load="getCinemaList"
				:immediate-check="false"
			>
				<cinema-table :list="cinemaList" @click="goCinema"></cinema-table>
			</van-list>
		</div>
		<div v-else style="margin-top: 10px" class="body-wrap fx-fill">
			<van-list
				v-model="listLoading"
				:finished="loadingPage"
				finished-text="- 我也是有底线的 -"
				@load="onLoad"
				:immediate-check="false"
			>
				<van-cell
					@click="showfilmDetail(item)"
					v-for="item in shops"
					:key="item.id"
					is-link
				>
					<template #title>
						<div>
							{{ item.supplierName }}
						</div>
						<div class="text-hidden-one" style="color: #797d82">
							{{ item.companyAddress }}
						</div>
					</template>
				</van-cell>
			</van-list>
		</div>
		<!-- 商品清单 弹出层 -->
		<van-popup
			v-model="filmDeatilShow"
			position="bottom"
			:style="{ height: '70%' }"
		>
			<van-nav-bar title="影院详情" @click-right="filmDeatilShow = false">
				<template #right>
					<van-icon name="cross" />
				</template>
			</van-nav-bar>
			<van-cell title="影院名称" :value="filmDeatil.supplierName" />
			<van-cell title="营业时间" :value="filmDeatil.businessHours" />
			<van-cell title="联系电话" :value="filmDeatil.contactPhone" />
			<van-cell title="影院地址" :value="filmDeatil.companyAddress" />
			<div style="height: 30px"></div>
			<van-button
				style="position: fixed; bottom: 0"
				block
				color="#1482ff"
				@click="toCard"
				>前往兑换</van-button
			>
		</van-popup>
	</div>
</template>

<script>
import Header from "@/components/header";
// import TabBar from '@/components/tab-bar';
import ScreenArea from "@/components/cinema/screen-area";
import CinemaTable from "@/components/cinema/cinema-table";
import { mapGetters } from "vuex";
import { getAMapLocation, getUserLocation } from "@/libs/map-utils.js";
import {
	cimeraDistance,
	cinemaDistancePrice,
	cardSupplier,
} from "@/utils/api.js";
export default {
	data() {
		return {
			movieId: this.$route.query.movieId,
			movieName: this.$route.query.movieName,
			filmDeatilShow: false,
			filmDeatil: {},
			cinemaList: [],
			pagination: this.$config.getDefaultPagination(),
			loadingPage: false,
			pageIndex: 0,
			loading: true,
			pageFlag: false,
			changeType: "1",
			shops: [],
			listLoading: false,
			listFinished: false,
			page: {
				pageSize: 10,
				current: 0,
			},
		};
	},
	methods: {
		goCinema(cinemaId, cinemaName) {
			this.$goPage("movie-session", {
				cinemaId,
				movieId: this.movieId,
				cinemaName,
			});
		},
		async nextPage() {
			let params = {
				cityId: this.currentCityId,
				citycode: this.currentCityCode,
				countycode: this.currentCountyCode ? this.currentCountyCode : "",
				countyName: this.currentCountyName,
				longitude: this.position ? this.position.lng : 121.34,
				latitude: this.position ? this.position.lat : 31.2,
				vcType: "wp",
				page_no: this.pagination.current_page,
				pageIndex: this.pageIndex,
			};
			this.movieId ? (params.movieid = this.movieId) : "";
			const res = await cinemaDistancePrice(params);

			console.log(res);
			if (res.data.cinemaList.length > 0) {
				this.pageIndex = res.data.pageIndex;
				this.cinemaList = [...this.cinemaList, ...res.data.cinemaList];
			} else {
				this.pageFlag = true;
			}
		},

		getAMapLocation() {
			getAMapLocation().then((res) => {
				console.log("qz", res);
				this.$store.commit("setLocation", res);
			});
		},
		async getCinemaList() {
			if (this.listFinished) return;
			this.listLoading = true;

			this.page.current++;
			let params = {
				cityId: this.currentCityId,
				citycode: this.currentCityCode,
				countyId: this.currentCountyCode ? this.currentCountyCode : "",
				countyName: this.currentCountyName,
				longitude: this.position ? this.position.lng : 121.34,
				latitude: this.position ? this.position.lat : 31.2,
				pageIdx: this.page.current,
				pageSize: this.page.pageSize,
			};
			this.movieId ? (params.movieid = this.movieId) : "";
			let res;
			if (this.$route.query.movieId) {
				res = await cinemaDistancePrice(params);

				this.cinemaList = [...this.cinemaList, ...res.data];
			} else {
				res = await cimeraDistance(params);
				this.cinemaList = [...this.cinemaList, ...res.data];
			}
			this.cinemaList.forEach((item) => {
				if (item.showTime) {
					item.playtimes = item.showTime.join(" | ");
				}
			});
			this.listLoading = false;

			if (!res.hasNext) {
				this.listFinished = true;
			}
			// if (this.cinemaList.length >= res.total || res.data.length == 0) {
			// 	this.listFinished = true;
			// 	console.log(this.cinemaList);
			// }
		},
		regionChange() {
			this.pagination = this.$config.getDefaultPagination();
			this.cinemaList = [];
			this.page.current = 0;
			this.listFinished = false;
			this.getCinemaList();
		},
		initPage() {
			if (this.changeType == "1") {
				this.pagination = this.$config.getDefaultPagination();
				this.cinemaList = [];
				this.page.current = 0;
				this.getCinemaList();
			} else if (this.changeType == "2") {
				this.getData();
			}
		},
		selectType(value) {
			this.changeType = value;
			this.getData();
		},
		showfilmDetail(item) {
			this.filmDeatilShow = true;
			this.filmDeatil = item;
		},

		toCard() {
			window.location = `${
				window.location.origin + "/shop/"
			}?t=${localStorage.getItem("t")}#/tickDetail`;
		},
		async getData() {
			this.page.pageIndex = 1;
			this.shops = [];
			this.listLoading = true;
			// let obj = this.$store.state.app.location
			// 	? this.$store.state.app.location
			// 	: this.$store.state.app.selectedLocation;

			const res = await cardSupplier({
				type: 1,
				pageIndex: this.page.pageIndex,
				pageSize: this.page.pageSize,
				cityCode: (this.currentCityCode + "").slice(0, 4),
				cityName: this.currentCityName,
				districtCode: this.currentCountyCode,
				qmmDistrictName:
					this.currentCountyName == "全城" ? "" : this.currentCountyName,
			});
			if (res.length === 0) {
				this.loadingPage = true;
				return;
			} else if (res.length < this.page.pageSize) {
				this.loadingPage = true;
			} else {
				this.loadingPage = false;
			}
			this.shops = res;
			this.listLoading = false;
		},

		async onLoad() {
			this.page.pageIndex++;
			this.listLoading = true;
			const res = await cardSupplier({
				type: 1,
				pageIndex: this.page.pageIndex,
				pageSize: this.page.pageSize,
				cityCode: (this.currentCityCode + "").slice(0, 4),
				cityName: this.currentCityName,
				districtCode: this.currentCountyCode,
				qmmDistrictName:
					this.currentCountyName == "全城" ? "" : this.currentCountyName,
			});
			this.listLoading = false;
			if (res.length === 0) {
				this.loadingPage = true;
				return;
			} else if (res.length < this.page.pageSize) {
				this.loadingPage = true;
			}
			this.shops = [...this.shops, ...res];
		},
	},

	mounted() {
		this.$store.commit("setSelectedCounty", null);
		this.initPage();

		// 注释定位
		// getUserLocation().then((change) => {
		// 	if (change) this.initPage();
		// });
	},
	computed: {
		...mapGetters([
			"currentCityCode",
			"currentCityName",
			"position",
			"currentCountyCode",
			"currentCountyName",
			"currentCityId",
		]),
	},
	components: {
		Header,
		// TabBar,
		ScreenArea,
		CinemaTable,
	},
};
</script>

<style lang="scss" scoped>
// .header-wrap {
// }
.body-wrap {
	position: relative;
	> div {
		position: absolute;
		width: 100%;
		top: 0;
		bottom: 0;
		overflow-y: scroll;
	}
}
.page {
	padding: 20px;
	text-align: center;
	background-color: #eeeeee;
}
// .footer-wrap {
//     padding-top: 50px;
// }
.loading-wave {
	width: 300px;
	height: 100px;
	display: flex;
	justify-content: center;
	align-items: flex-end;
}

.loading-bar {
	width: 20px;
	height: 10px;
	margin: 0 5px;
	background-color: #3498db;
	border-radius: 5px;
	animation: loading-wave-animation 1s ease-in-out infinite;
}

.loading-bar:nth-child(2) {
	animation-delay: 0.1s;
}

.loading-bar:nth-child(3) {
	animation-delay: 0.2s;
}

.loading-bar:nth-child(4) {
	animation-delay: 0.3s;
}

@keyframes loading-wave-animation {
	0% {
		height: 10px;
	}

	50% {
		height: 50px;
	}

	100% {
		height: 10px;
	}
}
</style>
